<a class="tag-default tag-pill">
  <label class="j-span2 label label-lg bg-default popular-tag">
    {{ tag }}
  </label>
</a>
